<template>
    <div>
      <div>
        <section class="block hero is-small is-primary">
          <div class="hero-body">
            <p class="title">
                Alege răspunsul corect
            </p>
            <p class="subtitle">
                (o singură variantă de răspuns)
            </p>
          </div>
        </section>
        <section class="block content has-text-justified">
            <div class="card">
                <header class="card-header">
                    <p class="card-header-title is-underlined is-size-3">Întrebare</p>
                </header>
                <div class="card-content">
                    <div class="content is-size-4">
                        {{ question.question }}
                    </div>
                    <div v-if="question.image !== null" class="columns is-mobile">
                        <div class="column is-three-fifths is-offset-one-fifth">
                            <b-image
                                :responsive="false"
                                :rounded="false"
                                :src="question.image"
                                alt="Imagine"
                            >
                            </b-image>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="block content has-text-justified">
            <div class="box" v-for="option in question.options" :key="option.answer_key">
                <b-field>
                    <b-radio v-model="answered"
                        :name="option.answer_key"
                        size="is-medium"
                        :native-value="option.answer_key">
                        <div class="is-size-5">{{ option.answer }}</div>
                    </b-radio>
                </b-field>
            </div>
        </section>
        <nav class="navbar is-transparent" style="margin: 0px">
            <div class="navbar-end">
                <div class="navbar-item">
                    <b-button 
                    v-on:click="nextQuestion" 
                    :disabled="answered === null" 
                    size="is-success is-rounded is-large" 
                    icon-right="content-save">Salvează răspunsul</b-button>
                </div>
            </div>
        </nav>
      </div>
    </div>
</template>

<script>
export default {
  props: ['quizToken', 'lastQuestion'],
  mounted() {
    this.answered = this.question.picked;
  },
  methods: {
      nextQuestion() {
          this.$emit("answered", this.answered, this.question)
      }
  },
  data() {
    return {
      token: JSON.parse(JSON.stringify(this.quizToken)),
      question: JSON.parse(JSON.stringify(this.lastQuestion)),
      answered: null
    }
  }
}
</script>
